import React from 'react';
import { makeStyles, TextField } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  skeleton: {
    borderRadius: theme.shape.borderRadius
  }
}));

function LoadTextField(props) {
  const classes = useStyles();
  const { loading, ...other } = props;

  return (
    <>
      {loading
        ? <Skeleton
            variant='rect'
            height={60}
            className={classes.skeleton}
            style={other.margin
              ? { marginTop: 16, marginBottom: 8 }
              : {}}
          />
        : <TextField {...other} fullWidth />}
    </>
  );
}

LoadTextField.propTypes = {
  loading: PropTypes.bool
}

export default LoadTextField;
